import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { DEFAULT_CALC_COLUMNS } from 'IndicesApp/ts/apps/index-family-app/constants';
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import { INITIAL_PAGINATION_STATE, PaginationControls, } from 'NewAngular/features/components/pagination/pagination.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { IndicesService } from 'IndicesApp/ts/shared/services/indices.service';
import { PaginationControlsComponent } from 'NewAngular/features/components/pagination/pagination-controls/pagination-controls.component';
import { getColumnHeaderClass } from 'IndicesApp/ts/shared/utils/utils';
import equal from 'NewAngular/utils/equal/deep-equal';
import { getNewSortDirectionCssClasses, getSortColumnAndDirection, initializeSortDirectionCssClasses, sortTableItems, } from 'NewAngular/utils/sort/table-sort';
import { setPreferenceIndicesCalcs } from 'IndicesApp/ts/apps/index-family-app/state/family-indices-table/family-indices-table.action';
import * as i0 from "@angular/core";
import * as i1 from "IndicesApp/ts/shared/services/indices.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "@ngrx/store";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/pagination/pagination-controls/pagination-controls.component";
import * as i7 from "IndicesApp/ts/apps/index-family-app/components/index-family-edit-columns-modal/index-family-edit-columns-modal.component";
const _c0 = () => [];
function FamilyIndicesTableComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "ycn-loading-symbol", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("loaderMessage", "Loading Indices...");
} }
function FamilyIndicesTableComponent_div_17_table_1_th_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 24);
    i0.ɵɵlistener("click", function FamilyIndicesTableComponent_div_17_table_1_th_3_Template_th_click_0_listener() { const calc_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r4 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r4.setSortBy(calc_r4.metricInternalName)); });
    i0.ɵɵelement(1, "div", 25);
    i0.ɵɵtext(2, " \u00A0 ");
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const calc_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r4.getHeaderClass(calc_r4));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(calc_r4.metricDisplayName);
} }
function FamilyIndicesTableComponent_div_17_table_1_tr_5_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 30);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const calc_r6 = ctx.$implicit;
    const row_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(row_r7.rowData[calc_r6]);
} }
function FamilyIndicesTableComponent_div_17_table_1_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 27)(2, "a", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td", 29);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, FamilyIndicesTableComponent_div_17_table_1_tr_5_ng_container_6_Template, 3, 1, "ng-container", 23);
    i0.ɵɵelement(7, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r7 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", row_r7.rowData.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(row_r7[ctx_r4.SYMBOL_COLUMN]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(row_r7[ctx_r4.NAME_COLUMN]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.columnNames);
} }
function FamilyIndicesTableComponent_div_17_table_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 21)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, FamilyIndicesTableComponent_div_17_table_1_th_3_Template, 5, 2, "th", 22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "tbody");
    i0.ɵɵtemplate(5, FamilyIndicesTableComponent_div_17_table_1_tr_5_Template, 8, 4, "tr", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.columnsInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.currentIndicesShown);
} }
function FamilyIndicesTableComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, FamilyIndicesTableComponent_div_17_table_1_Template, 6, 2, "table", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const noDataTemplate_r8 = i0.ɵɵreference(21);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.noData)("ngIfElse", noDataTemplate_r8);
} }
function FamilyIndicesTableComponent_ng_template_20_tr_4_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34)(1, "div", 35);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd()();
} }
function FamilyIndicesTableComponent_ng_template_20_tr_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, FamilyIndicesTableComponent_ng_template_20_tr_4_td_1_Template, 3, 0, "td", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(3));
} }
function FamilyIndicesTableComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 31)(1, "div", 32);
    i0.ɵɵtext(2, "No Data Available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "tbody");
    i0.ɵɵtemplate(4, FamilyIndicesTableComponent_ng_template_20_tr_4_Template, 2, 2, "tr", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(10));
} }
export class FamilyIndicesTableComponent {
    constructor(indicesService, accountsService, store) {
        this.indicesService = indicesService;
        this.accountsService = accountsService;
        this.store = store;
        this.pageChangeHandler = new EventEmitter();
        this.fetchSubscription = null;
        this.NAME_COLUMN = 'name';
        this.SYMBOL_COLUMN = 'symbol';
        this.BASE_COLUMN_INFO = [
            {
                metricDisplayName: 'Symbol',
                metricInternalName: this.SYMBOL_COLUMN,
                headerClass: 'text-left',
            },
            {
                metricDisplayName: 'Name',
                metricInternalName: this.NAME_COLUMN,
                headerClass: 'text-left',
            },
        ];
        this.PAGE_MAX = 25;
        this.paginationInfo = INITIAL_PAGINATION_STATE;
        this.indexFamilyTableData = [];
        this.sortedTableRows = [];
        this.currentIndicesShown = [];
        this.columnsInfo = [];
        this.columnNames = [];
        this.pageMappings = {};
        this.loading = true;
        this.rawSortBy = '';
        this.noData = true;
        this.mapStateToComponent = (state) => {
            const currColumns = state.preferenceIndicesCalcs;
            const prevColumns = this.columnNames;
            if (!equal(currColumns, prevColumns)) {
                // Check to see if there is already a fetch pending. If there is we need
                // "cancel" the request by unsubscribing from it before creating a new
                // subscription.
                if (this.fetchSubscription !== null) {
                    this.fetchSubscription.unsubscribe();
                }
                this.columnNames = state.preferenceIndicesCalcs;
                this.fetchSubscription = this.getTableData();
            }
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
        this.sortColumnAndDirection = {
            sortColumn: '',
            sortDirection: DESC,
        };
        const sortColumns = [this.SYMBOL_COLUMN, this.NAME_COLUMN];
        this.sortDirectionCssClasses = initializeSortDirectionCssClasses(sortColumns);
        this.paginationInfo.current_page_num = 1;
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe({
            next: (preference) => {
                this.columnNames = preference.indices_page_family_indices_columns;
                this.store.dispatch(setPreferenceIndicesCalcs({ calcs: this.columnNames }));
                this.fetchSubscription = this.getTableData();
            },
            error: () => {
                this.columnNames = DEFAULT_CALC_COLUMNS.map((calc) => calc.metricInternalName);
                this.store.dispatch(setPreferenceIndicesCalcs({ calcs: this.columnNames }));
                this.fetchSubscription = this.getTableData();
            },
        });
    }
    ngOnDestroy() {
        if (this.fetchSubscription !== null) {
            this.fetchSubscription.unsubscribe();
        }
        this.storeSubscription.unsubscribe();
    }
    getTableData() {
        this.loading = true;
        return this.indicesService.getIndicesData(this.indexFamily, this.columnNames).subscribe({
            next: (response) => {
                this.indexFamilyTableData = response.indicesData;
                this.columnsInfo = this.BASE_COLUMN_INFO.concat(response.columnInfo);
                this.noData = false;
                this.noData = this.indexFamilyTableData.length === 0;
                // format calcs data to enable sorting
                this.sortedTableRows = this.formatData(this.indexFamilyTableData);
                this.resetSortBy(this.columnNames);
                this.initializePagination();
                this.loading = false;
            },
            error: () => {
                this.noData = true;
                this.loading = false;
            },
        });
    }
    formatData(calcsData) {
        return calcsData.map((calcData) => {
            const indexFamilyPerformanceData = {};
            // manually add symbol & name because they are non-calc columns
            indexFamilyPerformanceData[this.SYMBOL_COLUMN] = calcData.label;
            indexFamilyPerformanceData[this.NAME_COLUMN] = calcData.value;
            // contains data needed in the template but cannot be sorted
            const rowData = { url: calcData.url, displayName: calcData.value };
            // add <calc base name, calc raw value> mapping to indexFamilyPerformanceData -- we want
            // to sort by raw value because the table-sort tool does not sort the formatted strings correctly
            calcData.data.forEach((calc) => {
                indexFamilyPerformanceData[calc.calc_name] = calc.calc_raw_value;
                rowData[calc.calc_name] = calc.calc_value;
            });
            indexFamilyPerformanceData.rowData = rowData;
            return indexFamilyPerformanceData;
        });
    }
    resetSortBy(columns) {
        this.sortColumnAndDirection = {
            sortColumn: '',
            sortDirection: DESC,
        };
        this.sortDirectionCssClasses = initializeSortDirectionCssClasses([
            this.SYMBOL_COLUMN,
            this.NAME_COLUMN,
            ...columns,
        ]);
        this.setSortBy(this.NAME_COLUMN);
    }
    setSortBy(newSortColumn) {
        const prevSortColumn = this.sortColumnAndDirection.sortColumn;
        this.sortColumnAndDirection = getSortColumnAndDirection({}, prevSortColumn, newSortColumn, this.sortColumnAndDirection.sortDirection);
        if (newSortColumn !== this.NAME_COLUMN && newSortColumn !== this.SYMBOL_COLUMN) {
            // display empty values at the bottom of the table by treating them as pos/neg infinity
            const nullValueModifier = this.sortColumnAndDirection.sortDirection === ASC ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
            this.sortedTableRows.forEach((item) => {
                if (!item.rowData[newSortColumn]) {
                    // eslint-disable-next-line no-param-reassign
                    item[newSortColumn] = nullValueModifier;
                }
            });
        }
        this.sortDirectionCssClasses = getNewSortDirectionCssClasses(this.sortDirectionCssClasses, prevSortColumn, newSortColumn, this.sortColumnAndDirection.sortDirection);
        this.sortedTableRows = sortTableItems(this.sortedTableRows, this.sortColumnAndDirection);
        this.paginationControlsComponent.pageChanged(PaginationControls.FIRST); // Sets currPage to 1 and disables prev/first buttons
        this.initializePagination();
    }
    initializePagination() {
        // initializes pageMappings dict for (key: value) (page_num: rows) pagination
        // 1-based to follow paginationInfo protocol
        this.paginationInfo.num_items = this.sortedTableRows.length;
        this.paginationInfo.num_pages = Math.floor(this.sortedTableRows.length / this.PAGE_MAX) + 1;
        for (let _i = 0; _i < this.paginationInfo.num_pages; _i += 1) {
            const start = _i * this.PAGE_MAX;
            let end = start + this.PAGE_MAX;
            if (end > this.sortedTableRows.length) {
                end = this.sortedTableRows.length;
            }
            this.pageMappings[_i + 1] = this.sortedTableRows.slice(start, end);
        }
        this.getCurrentRows();
    }
    getCurrentRows() {
        this.currentIndicesShown = this.pageMappings[this.paginationInfo.current_page_num];
        this.paginationInfo.start_index = this.PAGE_MAX * (this.paginationInfo.current_page_num - 1) + 1;
        this.paginationInfo.end_index = this.paginationInfo.start_index - 1 + this.currentIndicesShown.length;
    }
    pageChanged(newPageNum) {
        this.paginationInfo.current_page_num = newPageNum;
        this.getCurrentRows();
        this.pageChangeHandler.emit(newPageNum);
    }
    getHeaderClass(calc) {
        return getColumnHeaderClass(this.sortDirectionCssClasses, calc);
    }
}
FamilyIndicesTableComponent.ɵfac = function FamilyIndicesTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FamilyIndicesTableComponent)(i0.ɵɵdirectiveInject(i1.IndicesService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i3.Store)); };
FamilyIndicesTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FamilyIndicesTableComponent, selectors: [["ycn-family-indices-table"]], viewQuery: function FamilyIndicesTableComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PaginationControlsComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationControlsComponent = _t.first);
    } }, inputs: { indexFamily: "indexFamily" }, outputs: { pageChangeHandler: "pageChangeHandler" }, standalone: false, decls: 22, vars: 8, consts: [["editColumnsModal", ""], ["noDataTemplate", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], ["data-toggle", "modal", 1, "btn", "btn-secondary", 3, "click"], [1, "panel-pagination", "d-flex"], [1, "panel-pagination-content", "ml-auto"], [1, "panel-pagination-count"], [1, "panel-pagination-content", 3, "pageChangeHandler", "disableButtons", "paginationInfo"], [1, "panel-content"], [1, "divider-horizontal"], [1, "company-financials-table-wrap", 2, "margin-right", "0px"], ["class", "panel-content d-flex justify-content-center align-items-center", 4, "ngIf"], ["class", "company-financials-table", "style", "margin-left: 190px;", 4, "ngIf"], [1, "panel-content", "d-flex", "justify-content-center", "align-items-center"], [3, "loaderMessage"], [1, "company-financials-table", 2, "margin-left", "190px"], ["class", "table", 4, "ngIf", "ngIfElse"], [1, "table"], ["class", "user-select-none", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "user-select-none", 3, "click", "ngClass"], [1, "sort-mark"], [1, "d-inline", "text-underline-hover"], [1, "table-dynamic-name-middle"], [3, "href"], [1, "text-nowrap"], [1, "text-right"], [1, "table", "text-right"], [1, "panel-data-empty-message"], ["class", "td-index", 4, "ngFor", "ngForOf"], [1, "td-index"], [1, "td-ellipsis"]], template: function FamilyIndicesTableComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "h3", 4);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 5)(5, "div", 6)(6, "a", 7);
        i0.ɵɵlistener("click", function FamilyIndicesTableComponent_Template_a_click_6_listener() { i0.ɵɵrestoreView(_r1); const editColumnsModal_r2 = i0.ɵɵreference(19); return i0.ɵɵresetView(editColumnsModal_r2.openModal()); });
        i0.ɵɵtext(7, "Edit Columns");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9)(10, "div", 10);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "ycn-pagination-controls", 11);
        i0.ɵɵlistener("pageChangeHandler", function FamilyIndicesTableComponent_Template_ycn_pagination_controls_pageChangeHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.pageChanged($event)); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵelement(14, "div", 13);
        i0.ɵɵelementStart(15, "div", 14);
        i0.ɵɵtemplate(16, FamilyIndicesTableComponent_div_16_Template, 2, 1, "div", 15)(17, FamilyIndicesTableComponent_div_17_Template, 2, 2, "div", 16);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(18, "ycn-index-family-edit-columns-modal", null, 0);
        i0.ɵɵtemplate(20, FamilyIndicesTableComponent_ng_template_20_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.indexFamily, " Indices");
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate3("Viewing ", ctx.paginationInfo.start_index, "-", ctx.paginationInfo.end_index, " of ", ctx.paginationInfo.num_items, " Indices");
        i0.ɵɵadvance();
        i0.ɵɵproperty("disableButtons", ctx.loading)("paginationInfo", ctx.paginationInfo);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i5.LoadingSymbolComponent, i6.PaginationControlsComponent, i7.IndexFamilyEditColumnsModalComponent], encapsulation: 2 });
